var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmericanExpress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 36,
    viewBox: "0 0 54 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12628_54481)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12628_54481)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M0 -9H53.8659V20.1508L51.1997 24.3271L53.8659 28.0441V45H0V17.5197L1.66639 15.5986L0 13.761V-9Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M10.4563 28.6286V20.1506H19.4106L20.3713 21.4061L21.3638 20.1506H53.8656V28.0439C53.8656 28.0439 53.0157 28.6201 52.0326 28.6286H34.0357L32.9525 27.2922V28.6286H29.4031V26.3473C29.4031 26.3473 28.9182 26.6657 27.87 26.6657H26.6619V28.6286H21.2878L20.3285 27.3462L19.3544 28.6286H10.4563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M0 13.7608L2.01923 9.0415H5.51127L6.65721 11.685V9.0415H10.9981L11.6803 10.9522L12.3417 9.0415H31.828V10.0021C31.828 10.0021 32.8523 9.0415 34.5358 9.0415L40.8584 9.06365L41.9846 11.6726V9.0415H45.6173L46.6171 10.5401V9.0415H50.2832V17.5195H46.6171L45.659 16.016V17.5195H40.3217L39.7849 16.183H38.3501L37.8221 17.5195H34.2026C32.754 17.5195 31.828 16.5785 31.828 16.5785V17.5195H26.3705L25.2874 16.183V17.5195H4.99395L4.45758 16.183H3.02732L2.49474 17.5195H0V13.7608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M2.734 10.0869L0.010498 16.4349H1.78364L2.28616 15.1638H5.20754L5.70745 16.4349H7.51965L4.79875 10.0869H2.734ZM3.74164 11.5643L4.63211 13.7856H2.84856L3.74164 11.5643Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M7.70679 16.4337V10.0857L10.2265 10.0951L11.6921 14.1879L13.1225 10.0857H15.6221V16.4337H14.0391V11.7562L12.361 16.4337H10.9726L9.28985 11.7562V16.4337H7.70679Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M16.7053 16.4337V10.0857H21.8711V11.5057H18.3051V12.5915H21.7878V13.9279H18.3051V15.0555H21.8711V16.4337H16.7053Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M22.7878 10.0869V16.4349H24.3709V14.1797H25.0375L26.9356 16.4349H28.8701L26.7872 14.0962C27.642 14.0239 28.5239 13.2883 28.5239 12.1464C28.5239 10.8105 27.478 10.0869 26.3107 10.0869H22.7878ZM24.3709 11.5069H26.1805C26.6146 11.5069 26.9304 11.8473 26.9304 12.1751C26.9304 12.5968 26.5212 12.8433 26.2039 12.8433H24.3709V11.5069Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M30.7866 16.4337H29.1702V10.0857H30.7866V16.4337Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M34.6191 16.4337H34.2702C32.5821 16.4337 31.5571 15.1004 31.5571 13.2858C31.5571 11.4264 32.5706 10.0857 34.7024 10.0857H36.4521V11.5892H34.6385C33.7731 11.5892 33.161 12.2662 33.161 13.3015C33.161 14.5308 33.8609 15.0472 34.8691 15.0472H35.2857L34.6191 16.4337Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M38.0638 10.0869L35.3403 16.4349H37.1135L37.616 15.1638H40.5374L41.0373 16.4349H42.8495L40.1286 10.0869H38.0638ZM39.0715 11.5643L39.9619 13.7856H38.1784L39.0715 11.5643Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M43.0344 16.4337V10.0857H45.0471L47.617 14.0741V10.0857H49.2V16.4337H47.2525L44.6175 12.3409V16.4337H43.0344Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M11.5398 27.5426V21.1946H16.7056V22.6145H13.1395V23.7004H16.6223V25.0368H13.1395V26.1644H16.7056V27.5426H11.5398Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M36.8523 27.5426V21.1946H42.0181V22.6145H38.452V23.7004H41.9181V25.0368H38.452V26.1644H42.0181V27.5426H36.8523Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M16.9061 27.5426L19.4213 24.4077L16.8462 21.1946H18.8406L20.3742 23.1809L21.913 21.1946H23.8294L21.2881 24.3686L23.808 27.5426H21.8138L20.3248 25.5876L18.8719 27.5426H16.9061Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M23.9958 21.1958V27.5438H25.6206V25.5392H27.287C28.697 25.5392 29.7657 24.7893 29.7657 23.331C29.7657 22.1229 28.9275 21.1958 27.4927 21.1958H23.9958ZM25.6206 22.6314H27.3755C27.831 22.6314 28.1566 22.9113 28.1566 23.3623C28.1566 23.7859 27.8326 24.0931 27.3703 24.0931H25.6206V22.6314Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M30.4534 21.1946V27.5426H32.0364V25.2874H32.703L34.6011 27.5426H36.5357L34.4527 25.2039C35.3076 25.1315 36.1894 24.396 36.1894 23.254C36.1894 21.9182 35.1435 21.1946 33.9762 21.1946H30.4534ZM32.0364 22.6145H33.846C34.2801 22.6145 34.5959 22.9549 34.5959 23.2827C34.5959 23.7045 34.1868 23.951 33.8695 23.951H32.0364V22.6145Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M42.7511 27.5426V26.1644H45.9193C46.3881 26.1644 46.591 25.9105 46.591 25.6319C46.591 25.3651 46.3887 25.0953 45.9193 25.0953H44.4876C43.2431 25.0953 42.55 24.3352 42.55 23.194C42.55 22.1762 43.1847 21.1946 45.034 21.1946H48.1168L47.4503 22.6229H44.784C44.2744 22.6229 44.1175 22.891 44.1175 23.147C44.1175 23.4102 44.3114 23.7004 44.7007 23.7004H46.2005C47.5877 23.7004 48.1897 24.4892 48.1897 25.5223C48.1897 26.6329 47.5189 27.5426 46.125 27.5426H42.7511Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M48.5614 27.5426V26.1644H51.7296C52.1984 26.1644 52.4013 25.9105 52.4013 25.6319C52.4013 25.3651 52.199 25.0953 51.7296 25.0953H50.2979C49.0534 25.0953 48.3604 24.3352 48.3604 23.194C48.3604 22.1762 48.995 21.1946 50.8443 21.1946H53.9271L53.2606 22.6229H50.5944C50.0847 22.6229 49.9278 22.891 49.9278 23.147C49.9278 23.4102 50.1217 23.7004 50.511 23.7004H52.0108C53.3981 23.7004 54 24.4892 54 25.5223C54 26.6329 53.3292 27.5426 51.9353 27.5426H48.5614Z",
    fill: "#016FD0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12628_54481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 36,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12628_54481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 36,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpress);
export default __webpack_public_path__ + "static/media/american-express.164709b8105f41ee6448d69a5194e9d2.svg";
export { ForwardRef as ReactComponent };